import { buildLocale } from "../../helpers/locale";

export default defineI18nLocale(locale => buildLocale(locale));